import { CustomerInvoiceTable } from "../CustomerInvoiceTable";

export const RecentInvoices = ({
  customerId,
  emptyStateAction,
}: {
  customerId: string;
  emptyStateAction?: () => void;
}) => (
  <div className="gap-[28px] md:mt-[40px] mt-[20px]">
    <h3 className="text-[18px] font-semibold">Recent Invoices</h3>
    <div className="mt-[1em]">
      <CustomerInvoiceTable
        customerId={customerId}
        emptyStateAction={emptyStateAction}
      />
    </div>
  </div>
);
